const initialState ={
    clearCheckInDate :false,
    clearCheckOutDate: false,
    selectedCheckInDate:undefined,
    checkOutContainerClicked:false,
    checkInContainerClicked:false
}

export default function TypeAheadReducer(state=initialState, action){
    switch (action.type) {
        case "CLEAR_CHECKIN_DATE":
        return{
            ...state,
            clearCheckInDate:action.payload.clearClicked,
            selectedCheckInDate:action.payload.selectedCheckInDate,
            clearCheckOutDate:false
        }
        case "CLEAR_CHECKOUT_DATE":
            return{
                ...state,
                clearCheckOutDate:action.payload.clearClicked,
                clearCheckInDate:false
            }
        case "CHECKOUT_CONTAINER_CLICK":
                return{
                    ...state,
                    checkOutContainerClicked:action.payload
                    
                }
        case "CHECKIN_CONTAINER_CLICK":
            return{
                ...state,
                checkInContainerClicked:action.payload,
                checkOutContainerClicked:false
            }               
    
        default:
            return{...state} 
           
    }

}